// see https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ConfirmSignUp.html#API_ConfirmSignUp_Errors

const ERRORS = [
  {
    code: 'AliasExistsException',
    msg: 'Dieser Account wird bereits verwendet.',
  },
  {
    code: 'CodeMismatchException',
    msg: 'Falscher Verifikationscode.',
  },
  {
    code: 'ExpiredCodeException',
    msg: 'Der Verifikationscode ist abgelaufen.',
  },
  {
    code: 'InternalErrorException',
    msg: 'Interner AWS Cognito Fehler.',
  },
  {
    code: 'InvalidLambdaResponseException',
    msg: 'Interner AWS Lambda Fehler.',
  },
  {
    code: 'InvalidParameterException',
    msg: 'Ungültiger Parameter.',
  },
  {
    code: 'LimitExceededException',
    msg: 'Deine Aktion hat das zulässige Limit überschritten. Versuche es später erneut.',
  },
  {
    code: 'NotAuthorizedException',
    msg: 'Du hast nicht die Berechtigung diese Aktion auszuführen.',
    msgSubErrors: [
      {
        key: 'User cannot be confirmed. Current status is CONFIRMED',
        exception: "AlreadyConfirmedException",
        msg: 'Benutzer wurde bereits aktiviert.',
      },
    ],
  },
  {
    code: 'ResourceNotFoundException',
    msg: 'Die Resource wurde nicht gefunden.',
  },
  {
    code: 'TooManyFailedAttemptsException',
    msg: 'Die Prüfung des Verifikationscode wurde zu oft aufgerufen. Versuche es später erneut.',
  },
  {
    code: 'TooManyRequestsException',
    msg: 'Deine Aktion hat das zulässige Limit überschritten. Versuche es später erneut.',
  },
  {
    code: 'UnexpectedLambdaException',
    msg: 'Interner AWS Lambda Fehler.',
  },
  {
    code: 'UserLambdaValidationException',
    msg: 'User Validierungsfehler.',
  },
  {
    code: 'UserNotFoundException',
    msg: 'Falscher Benutzername oder Code.',
  }
]

export {ERRORS}
